// theme-bundels/assets/bundels-v2-keuze.js — pure keuzelogica voor de V2-bundelhero (ES5; browser: window.StaneBundelKeuze)
// Eén definitie van "koopbaar" (eindreview I1, zoals v2Koopbaar in de set-kaart): de combinatie maat|blad|frame
// bestaat in de configurator (`bestaand`) ÉN de variant is beschikbaar (`available === true`).
(function (root) {
  var MATEN = ['120x60', '140x60', '140x80', '160x80'];
  var TEKST_VANAF = 'Deze combinatie is er vanaf [maat]';
  var TEKST_NIET_LEVERBAAR = 'Deze combinatie is niet leverbaar';
  function sleutel(v) { return v.maat + '|' + v.blad + '|' + v.frame; }
  function bestaat(v, bestaand) { return bestaand.indexOf(sleutel(v)) !== -1; }
  function koopbaar(v, bestaand) { return !!v && v.available === true && bestaat(v, bestaand); }
  function opMaat(a, b) { return MATEN.indexOf(a.maat) - MATEN.indexOf(b.maat); }
  /* zelfde blad + frame: eerstvolgende maat na de gekozen, anders de kleinste */
  function zelfdeKleur(lijst, keuze) {
    var z = lijst.filter(function (v) { return v.blad === keuze.blad && v.frame === keuze.frame; }).sort(opMaat);
    return z.filter(function (v) { return MATEN.indexOf(v.maat) > MATEN.indexOf(keuze.maat); })[0] || z[0] || null;
  }
  /* teksten (sectie-instellingen): { vanaf: '… [maat] …', nietLeverbaar: '…' } */
  function kiesVariant(variants, bestaand, keuze, teksten) {
    var t = teksten || {};
    var echt = variants.filter(function (v) { return koopbaar(v, bestaand); });
    var exact = echt.filter(function (v) { return sleutel(v) === sleutel(keuze); })[0];
    if (exact) return { variant: exact, melding: '', koopbaar: true };
    var gekozen = zelfdeKleur(echt, keuze);
    if (gekozen) return { variant: gekozen, melding: (t.vanaf || TEKST_VANAF).replace('[maat]', gekozen.maat.replace('x', '×') + ' cm'), koopbaar: true };
    /* deze kleur is in geen enkele maat koopbaar: niet stil wisselen, maar "niet leverbaar" tonen. Getoond wordt de
       bestaande (niet beschikbare) combinatie zelf of dezelfde kleur in de eerstvolgende bestaande maat, zodat prijs en beeld kloppen. */
    var bestaandeVarianten = variants.filter(function (v) { return bestaat(v, bestaand); });
    var toon = bestaandeVarianten.filter(function (v) { return sleutel(v) === sleutel(keuze); })[0] || zelfdeKleur(bestaandeVarianten, keuze);
    return { variant: toon, melding: t.nietLeverbaar || TEKST_NIET_LEVERBAAR, koopbaar: false };
  }
  function vanUrl(variants, id) {
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return variants[0];
  }
  function kleurenBijMaat(bestaand, maat) {
    return bestaand.filter(function (s) { return s.split('|')[0] === maat; }).map(function (s) { return s.split('|').slice(1).join('|'); });
  }
  function zusterUrl(url, zusterVarianten, keuze) {
    var v = zusterVarianten.filter(function (x) { return sleutel(x) === sleutel(keuze); })[0];
    return v ? url + '?variant=' + v.id : url;
  }
  var api = { kiesVariant: kiesVariant, koopbaar: koopbaar, vanUrl: vanUrl, kleurenBijMaat: kleurenBijMaat, zusterUrl: zusterUrl, MATEN: MATEN };
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.StaneBundelKeuze = api;
})(this);
